





import Vue from 'vue'
import Mailing from '@/models/mailing/mailing'
import UiTag from '@/components/Ui/Tag/Tag.vue'

export default Vue.extend({
  name: 'TypeColumn',
  props: {
    row: Object as () => Mailing
  },
  components: {
    UiTag
  }
})
